'use strict';

/**
 * ChartItem
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.ChartItem = T.createModule({

	_selectors: {
		chartCanvas: '[data-js-m-chart-canvas]',
		chartCanvasInner: '[data-js-m-chart-canva-inner]',
		chartData: '[data-js-m-chart-data]'
	},

	_stateClasses: {
		chartEnteredScreen: 'state-entered-screen'
	},

	_highChartsLegend: {
		symbolRadius: 0,
		useHTML: true,
		itemMarginBottom: 10,
		floating: true
	},

	_highChartsXAxis: {
		tickLength: 0
	},

	_highChartsYAxis: {
		min: 0,
		title: {
			text: ''
		}
	},

	_highChartsTooltip: {
		useHTML: true,
		headerFormat: ''
	},

	// borderWidth prevents border between segments in one stack
	// pointWidth sets the width of the bars
	_highChartsPlotOptions: {
		series: {
			pointWidth: 30
		},
		column: {
			borderWidth: 0
		}
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		this.$chartCanvas = this.$ctx.find(this._selectors.chartCanvas);
		this.$chartCanvasInner = this.$ctx.find(this._selectors.chartCanvasInner);
		this.$chartData = this.$ctx.find(this._selectors.chartData);

		this.type = this.$ctx.data('chart-type');
		this.disableLegendClick = this.$ctx.data('disable-legend-click') || false;
		this.moduleId = this.$ctx.data('t-id');

		this.hasBeenInitialized = false;
		this.waypointsInitialized = false;

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));
		this._events.on('charts.libraryLoaded', this.initializeHighcharts.bind(this));

		// …

		// Lifecycle Callback
		resolve();
	},
	sync: function sync() {},


	/**
  * Initialize the highcharts
  *
  * @returns {void}
  */
	initializeHighcharts: function initializeHighcharts() {

		// only initialize it once, if there are multiple chart components on one page
		if (!this.hasBeenInitialized) {
			this.defineRenderingDelay(Highcharts);

			// check if the needed divs are available on the page
			if (this.$chartData.length > 0 && this.$chartCanvasInner.length > 0) {
				var chartDataHTML = this.$chartData[0].innerHTML;

				// extend options with categories from data attribute
				var categoriesString = this.$chartData.data('categories');
				var categoriesArray = categoriesString.split(',');

				$.extend(this._highChartsXAxis, {
					categories: categoriesArray
				});

				if (this.type === 'percent') {
					$.extend(this._highChartsPlotOptions.column, {
						stacking: 'percent'
					});

					$.extend(this._highChartsYAxis, {
						tickInterval: 10,
						minorTickInterval: 5
					});

					$.extend(this._highChartsTooltip, {
						pointFormat: '<span class="tooltip-content">' + '<span class="tooltip-series-name">{series.name}</span><br />' + '{point.x}: <span class="tooltip-percentage">{point.y}%</span>'
					});
				} else {
					$.extend(this._highChartsPlotOptions.column, {
						stacking: 'normal'
					});

					$.extend(this._highChartsYAxis, {
						tickInterval: 200,
						minorTickInterval: 100
					});

					$.extend(this._highChartsTooltip, {
						pointFormat: '<span class="tooltip-content">' + '<span class="tooltip-series-name">{series.name}</span><br />' + '{point.x}: <span class="tooltip-percentage">{point.percentage:.0f}%</span>' + '<br/>CHF <span class="tooltip-y-value">{point.y}</span> Mio</b></span>'
					});
				}

				// extend options with the click listener to enable / disable the legend items properly
				$.extend(this._highChartsPlotOptions.series, {
					events: {
						legendItemClick: this.onLegendItemClick.bind(this)
					}
				});

				Highcharts.chart({
					title: {
						text: ''
					},
					credits: {
						enabled: false
					},
					chart: {
						renderTo: this.$chartCanvasInner[0],
						type: 'column',
						events: {
							redraw: this.updateLegendMargin.bind(this)
						}
					},
					// eslint-disable-next-line id-blacklist
					data: {
						csv: chartDataHTML,
						itemDelimiter: ','
					},
					legend: this._highChartsLegend,
					xAxis: this._highChartsXAxis,
					yAxis: this._highChartsYAxis,
					tooltip: this._highChartsTooltip,
					plotOptions: this._highChartsPlotOptions
				});

				// normal classes are used, because there is no option to specify a data-js-xx attribute on the legend
				this.$legend = this.$ctx.find('.highcharts-container > .highcharts-legend');

				this.updateLegendMargin();
			}

			this.hasBeenInitialized = true;
		}
	},


	/**
  * Define a delayed rendering function for highcharts to only render the bars, when the element is in the viewport
  *
  * @param {Object} Highcharts The Highcharts Plugin
  * @returns {void}
  */
	defineRenderingDelay: function defineRenderingDelay(Highcharts) {

		var mod = this; // eslint-disable-line consistent-this
		var delayedRendering = function delayedRendering(proceed) {
			var series = this; // eslint-disable-line consistent-this

			if (mod.$ctx.hasClass('state-entered-screen') || !series.options.animation) {
				// It entered screen, render it
				proceed.call(series);
			} else {
				// It has not entered screen, and waypoints has not been initialized
				mod.initializeWaypoints();

				$(document).on('charts.enteredScreen.' + [mod.moduleId], function () {
					proceed.call(series);
				});
			}
		};

		Highcharts.wrap(Highcharts.Series.prototype, 'render', delayedRendering);
	},


	/**
  * Initialize the waypoints to check if the chart is visible
  *
  * @returns {void}
  */
	initializeWaypoints: function initializeWaypoints() {
		if (!this.waypointsInitialized) {
			// eslint-disable-next-line no-new
			new Waypoint.Inview({
				element: this.$ctx[0],
				entered: this.onChartsEnteredScreen.bind(this)
			});

			this.waypointsInitialized = true;
		}
	},


	/**
  * Event when the charts enters the screen
  *
  * @param {Object} direction The direction, the charts entered
  * @returns {void}
  */
	onChartsEnteredScreen: function onChartsEnteredScreen(direction) {
		// console.log('charts enter screen, direction: ' + direction);
		if (direction === 'down') {
			this.$ctx.addClass(this._stateClasses.chartEnteredScreen);

			// top of the charts enter at the bottom of screen
			$(document).trigger('charts.enteredScreen.' + [this.moduleId], {});
		}
	},


	/**
  * Update the margin on the canvas which is needed to fit the legend below the chart
  *
  * @returns {void}
  */
	updateLegendMargin: function updateLegendMargin() {
		var newHeight = this.$legend.height();
		this.$chartCanvas.css('margin-bottom', newHeight + 'px');
	},


	/**
  * Event when the user clicks on a legend item.
  *
  * @param {Object} ev The event.
  * @returns {boolean} Boolean if the event should be cancelled
  */
	onLegendItemClick: function onLegendItemClick(ev) {
		if (this.disableLegendClick) {
			return false;
		}

		this.$legend.find('.highcharts-legend-item.highcharts-series-' + ev.target.index).toggleClass('inactive');
		return true;
	}
});